.infoGridValue {
    color: var(--info-grid-value-color);
    font-size: var(--info-grid-value-font-size);
    line-height: var(--info-grid-value-line-height);
    overflow-wrap: break-word;

    &.empty {
        color: var(--info-grid-empty-value-color);
        font-style: italic;
    }
}
